<div class="form-sec-col panel" [formGroup]="form">
  <mat-toolbar color="accent">
    <mat-toolbar-row>
      Export
      <span class="toolbar-spacer"></span>
      <button mat-icon-button (click)="closeSidePanel()" class="btn">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="panel-content">

    <h4>Observations to download</h4>
    <mat-radio-group class="radio-btn" aria-label="Select an option" formControlName="download_options">
      @for (option of observationOptions; track option) {
        <mat-radio-button [value]="option.value" [disabled]="option.disabled">
          {{option.name}}
        </mat-radio-button>
      }
    </mat-radio-group>
    <!--
    <h4>Geographical limits</h4>
    <mat-checkbox class="space-checkbox" formControlName="geo_limits">
      Limit to map extent
    </mat-checkbox> -->


    <h4>Download format</h4>
    <mat-radio-group class="radio-btn" aria-label="Select an option" formControlName="download_formats">
      @for (option of formatOptions; track option) {
        <mat-radio-button [value]="option.value" [disabled]="option.disabled">
          {{option.name}}
        </mat-radio-button>
      }
    </mat-radio-group>

    <div class="button-row">
      <button type="button" mat-stroked-button color="primary" [disabled]="resetDisabled"
      (click)="reset()">Reset</button>
      <button type="submit" mat-stroked-button color="accent" [disabled]="exportDisabled"
      (click)="submit()">Export</button>
    </div>

    <!-- <br>{{form.value | json}}<br>{{form.valid}} -->
  </div>
</div>